module.exports = __webpack_public_path__ + "img/VW.74bbd540.webp";